// Copyright (c) 2022 Deere & Company

import {getStore} from '../../store-factory';
import {updateSessionExpiredModalVisibility} from '../../shared/action-creators/session-expired-modal-visibility';

export const oktaLoginRequired = (isVisible = true) => {

    const dispatch = getStore().dispatch;

    dispatch(updateSessionExpiredModalVisibility(isVisible));

};



// WEBPACK FOOTER //
// ./src/shared/services/okta-login-required.js